import React from 'react';
import { HudIcon } from '../Icons/HudIcons';
import LongContentPopover from '../LongContentPopover/LongContentPopover';
import MultiSelect, { MultiSelectProps } from '../MultiSelect/MultiSelect';
import Styled from './Filters.styles';

export interface FilterProps {
  label: string;
  onClear: () => void;
}

export const FlagFilter: React.FC<FilterProps> = ({ label, onClear }) => {
  return (
    <Styled.Container>
      <Styled.Label>{label}</Styled.Label>
      <Styled.ClearButton onClick={onClear}>
        <HudIcon icon="other.close" size="20px" />
      </Styled.ClearButton>
    </Styled.Container>
  );
};

export interface MultiSelectFilterProps extends FilterProps, MultiSelectProps {
  multiSelectLabel: string | React.ReactNode;
}

export const MultiSelectFilter: React.FC<MultiSelectFilterProps> = ({
  label,
  multiSelectLabel,
  selectedOptions,
  mainGroupOption,
  options,
  searchTerm,
  optionReverseEllipsis,
  onClear,
  onChange,
  onSearch,
  onClose,
}: MultiSelectFilterProps) => {
  return (
    <Styled.Container>
      <Styled.Label>{label}</Styled.Label>
      <MultiSelect
        mainGroupOption={mainGroupOption}
        options={options}
        selectedOptions={selectedOptions}
        searchable
        optionReverseEllipsis={optionReverseEllipsis}
        searchTerm={searchTerm}
        renderButton={({ onClick }) => (
          <Styled.Content onClick={onClick}>
            <LongContentPopover reverseEllipsis={optionReverseEllipsis}>
              {multiSelectLabel}
            </LongContentPopover>
          </Styled.Content>
        )}
        onChange={onChange}
        onSearch={onSearch}
        onClose={onClose}
        position="bottom-start"
      />
      <Styled.ClearButton onClick={onClear}>
        <HudIcon icon="other.close" size="20px" />
      </Styled.ClearButton>
    </Styled.Container>
  );
};
